import * as React from "react";
import { useFormContext } from "react-hook-form";
import { NGLabelText } from "../../../newcomponents/text/labelText";
import { FormDryRunAlert } from "./formDryRunAlert";
import { Gvc } from "../../../schema/types/gvc";
import { FormNGKindSelect } from "./components/FormNGKindSelect";
import { DomainInput } from "./types/input";
import { linksOf } from "../../../services/cpln";

interface Props {}
export const CreateNGAdvancedGvcSubdomain: React.FC<Props> = ({}) => {
  const { control, watch, setValue } = useFormContext<DomainInput>();

  const dryRunNameOnly = watch("dryRun.nameOnly.value") || {};
  const routingMode = watch("advanced.spec.routingMode") || "";

  if (dryRunNameOnly.status !== 200) {
    return null;
  }

  if (routingMode !== "gvcSubdomain") {
    return null;
  }

  return (
    <div className="mb-8">
      <div className="flex items-center">
        <NGLabelText className="cursor-default">GVC Selection</NGLabelText>
        <span className="color-danger">*</span>
      </div>
      <FormNGKindSelect<Gvc>
        name="gvc.name"
        control={control}
        rules={{ required: "GVC is required" }}
        kind="gvc"
        optionValueAs="name"
        className="color-default"
        style={{ width: 600 }}
        onChangeExtra={(_, item) => {
          const link = linksOf(item).self!;
          setValue(`gvc.link`, link);
          setValue(`gvc.alias`, item.alias || "");
        }}
      />
      <FormDryRunAlert path={"spec.gvcLink"} />
    </div>
  );
};
